/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
import React, { useContext, useRef, useState } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import cls from 'classnames';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';

import LeadButton from '@/components/LeadButton';
import Title from '@/components/Title';

import useIsMobileNew from '@/hooks/useIsMobileNew';

import { MyContext } from '@/config/context-manager';

import Modal from '../Modal';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import styles from './style.module.scss';

const courseConfig = [
  {
    title: '分级课程-主课程-2-标题',
    age: '分级课程-主课程-2-年龄',
    tag: '分级课程-主课程-2-标签',
    course: '分级课程-主课程-2-对标课程',
    tap: true,
    imgMobile: '/images/chinese/course/course-ladder-m-zh-tab1.png',
    imgMobileEn: '/images/chinese/course/course-ladder-m-en-tab1.png',
    imgMobileL: '/images/chinese/course/course-lager-zh-1.png',
    imgMobileLEn: '/images/chinese/course/course-lager-en-1.png',
    id: 1,
  },
  {
    title: '分级课程-主课程-4-标题',
    age: '分级课程-主课程-4-年龄',
    tag: '分级课程-主课程-4-标签',
    course: '分级课程-主课程-4-对标课程',
    tap: false,
    imgMobile: '/images/chinese/course/course-ladder-m-zh-tab2.png',
    imgMobileEn: '/images/chinese/course/course-ladder-m-en-tab2.png',
    imgMobileL: '/images/chinese/course/course-ladder-m-zh-tab2.png',
    imgMobileLEn: '/images/chinese/course/course-ladder-m-en-tab2.png',
    id: 2,
  },
  {
    title: '分级课程-主课程-1-标题',
    age: '分级课程-主课程-1-年龄',
    tag: '分级课程-主课程-1-标签',
    course: '分级课程-主课程-1-对标课程',
    tap: false,
    imgMobile: '/images/chinese/course/course-ladder-m-zh-tab3.png',
    imgMobileEn: '/images/chinese/course/course-ladder-m-en-tab3.png',
    imgMobileL: '/images/chinese/course/course-lager-zh-3.png',
    imgMobileLEn: '/images/chinese/course/course-lager-en-3.png',
    id: 3,
  },
  {
    title: '分级课程-主课程-3-标题',
    age: '分级课程-主课程-3-年龄',
    tag: '分级课程-主课程-3-标签',
    course: '分级课程-主课程-3-对标课程',
    tap: false,
    imgMobile: '/images/chinese/course/course-ladder-m-zh-tab4.png',
    imgMobileEn: '/images/chinese/course/course-ladder-m-en-tab4.png',
    imgMobileL: '/images/chinese/course/course-lager-zh-4.png',
    imgMobileLEn: '/images/chinese/course/course-lager-en-4.png',
    id: 4,
  },
];

const courseRightImgConfig = [
  {
    img: '/images/chinese/course/course-ladder-pc-zh-tab1.png',
    imgEn: '/images/chinese/course/course-ladder-pc-en-tab1.png',
    id: 1,
  },
  {
    img: '/images/chinese/course/course-ladder-pc-zh-tab2.png',
    imgEn: '/images/chinese/course/course-ladder-pc-en-tab2.png',
    id: 2,
  },
  {
    img: '/images/chinese/course/course-ladder-pc-zh-tab3.png',
    imgEn: '/images/chinese/course/course-ladder-pc-en-tab3.png',
    id: 3,
  },
  {
    img: '/images/chinese/course/course-ladder-pc-zh-tab4.png',
    imgEn: '/images/chinese/course/course-ladder-pc-en-tab4.png',
    id: 4,
  },
];

const minorConfig = [
  {
    title: '分级课程-辅修课-课程1-名称',
    img: '/images/chinese/minor-swiper-img-1.png',
    id: 1,
  },
  {
    title: '分级课程-辅修课-课程3-名称',
    img: '/images/chinese/minor-swiper-img-3.png',
    id: 3,
  },
  {
    title: '分级课程-辅修课-课程4-名称',
    img: '/images/chinese/minor-swiper-img-4.png',
    id: 4,
  },
  {
    title: '分级课程-辅修课-课程5-名称',
    img: '/images/chinese/minor-swiper-img-5.png',
    id: 5,
  },
  {
    title: '分级课程-辅修课-课程6-名称',
    img: '/images/chinese/minor-swiper-img-6.png',
    id: 6,
  },
];

const Course = () => {
  const { t } = useTranslation(['chinese', 'path']);
  const { locale } = useContext(MyContext);
  const isEn = locale === 'en';
  const swiperRef = useRef<SwiperRef['swiper']>();
  const [courseList, setCourseList] = useState(courseConfig);
  const [swiperIndex, setSwiperIndex] = useState<number>(1);
  const [courseClickId, setCourseClickId] = useState<number>(1);
  const [visible, setVisible] = useState(false);
  const [modalImgSrc, setModalSrc] = useState('');
  const isSmallScreen = useIsMobileNew();

  const handleClickCourseTab = (id: number, status: boolean) => {
    if (status) {
      return;
    }
    setCourseClickId(id);
    const arr: any = [];
    courseList.map((item) => {
      item.tap = item.id === id;
      arr.push(item);
      setCourseList([...arr]);
    });
  };
  const handleCourseImgModal = (imgsrc: string) => {
    setModalSrc(imgsrc);
    setVisible(true);
  };

  return (
    <section
      className={cls(
        'relative mt-[80px] overflow-hidden pt-0 text-center lg:mt-[140px] lg:pb-[58px] lg:pt-[58px] xl:mt-[180px] xl:pt-[58px]',
      )}
    >
      <div className="container">
        <Title className="" innerHTML theme="red">
          {`${t('分级课程-标题')}`}
        </Title>
        <div
          className={cls(
            'relative m-auto mt-6 text-left text-wk-words-2 lg:mt-6 lg:h-[108px] lg:w-[672px] lg:pl-[47px] lg:text-[16px] lg:leading-6 xl:mt-10 xl:h-[132px] xl:w-[927px] xl:pl-[47px] xl:text-[18px] xl:leading-[30px]',
            isEn && ' lg:h-[180px] xl:h-[180px]',
          )}
        >
          <div
            style={
              isSmallScreen
                ? {
                    background:
                      'linear-gradient(184deg, rgba(255, 83, 83, 0.03) 11.74%, rgba(109, 56, 251, 0.03) 60.79%, rgba(0, 157, 255, 0.03) 90.39%), radial-gradient(131.04% 104.72% at 17.91% -14.45%, #FFF0F0 0%, rgba(255, 255, 255, 0.00) 30.77%), #FFF',
                  }
                : {}
            }
            className="relative mb-3 w-[100%] rounded-[24px] border-2 border-white p-4 shadow-[0px_12px_30px_0px_rgba(0,0,0,0.06)] lg:mb-0 lg:border-none lg:bg-transparent lg:p-0 lg:shadow-none xl:mb-0 xl:border-none xl:bg-transparent xl:p-0 xl:shadow-none"
          >
            <h3
              className={cls(
                `${`pl-[33px] after:absolute after:left-[16px] after:top-[20px] after:h-[20px] after:w-[20px] after:bg-[url("/images/chinese/course-title-icon.png")] after:bg-contain after:bg-no-repeat lg:mb-3 lg:pl-0 after:lg:left-[-32px] after:lg:top-[5px] lg:after:block xl:mb-3 xl:pl-0 after:xl:left-[-31px] after:xl:top-[5px]`}`,
              )}
            >
              {t('分级课程-副标题1')}
            </h3>
          </div>
          <div
            style={
              isSmallScreen
                ? {
                    background:
                      'linear-gradient(184deg, rgba(255, 83, 83, 0.03) 11.74%, rgba(109, 56, 251, 0.03) 60.79%, rgba(0, 157, 255, 0.03) 90.39%), radial-gradient(131.04% 104.72% at 17.91% -14.45%, #FFF0F0 0%, rgba(255, 255, 255, 0.00) 30.77%), #FFF',
                  }
                : {}
            }
            className="relative w-[100%] rounded-[24px] border-2 border-white p-4 shadow-[0px_12px_30px_0px_rgba(0,0,0,0.06)] lg:border-none lg:bg-transparent lg:p-0 lg:shadow-none xl:border-none xl:bg-transparent xl:p-0 xl:shadow-none"
          >
            <h3
              className={cls(
                `${`pl-[33px] after:absolute after:left-[16px] after:top-[20px] after:h-[19px] after:w-[20px] after:bg-[url("/images/chinese/course-title-icon.png")] after:bg-contain after:bg-no-repeat lg:mb-3 lg:pl-0 after:lg:left-[-32px] after:lg:top-[5px] lg:after:block xl:mb-3 xl:pl-0 after:xl:left-[-32px] after:xl:top-[5px]`}`,
              )}
            >
              {t('分级课程-副标题2')}
            </h3>
          </div>
        </div>
      </div>
      <div
        className={cls(
          'container mb-10 mt-[48px] rounded-[36px] bg-[#fff] lg:h-[458px] lg:w-[984px] lg:px-[30px] lg:py-[22px] lg:shadow-wk1 xl:h-[566px] xl:w-[1220px] xl:px-[60px] xl:py-[52px] xl:shadow-wk1',
          isEn && 'lg:h-[690px] xl:h-[810px]',
          !isEn && 'lg:h-[515px] xl:h-[640px]',
        )}
      >
        <div className="mb-5 h-[32px] text-[22px] font-bold text-wk-words-1 lg:w-[310px] xl:w-[310px]">
          <p>{t('分级课程-主课程-标题')}</p>
        </div>
        <div className="hidden lg:flex xl:flex">
          <div>
            {courseList.map((item) => (
              <div key={item.title} className="relative flex">
                <h3
                  className={cls(
                    'mb-[10px] flex cursor-pointer flex-col rounded-xl border border-solid border-[#EBECFA] bg-[#F8F9FF] text-left text-[12px] text-wk-words-2 lg:h-[81px] lg:w-[290px] lg:p-3 xl:h-[91px] xl:w-[310px] xl:p-5',
                    item.tap &&
                      'border-[#FF9AA9] bg-[linear-gradient(90deg,rgba(255,29,67,0.75)0%,rgba(255,118,90,0.75)100%)] shadow-[0px_8px_30px_0px_rgba(113,50,50,0.10)] [&]:text-[#fff]',
                    isEn && 'lg:p-3 [&]:lg:h-[131px] [&]:lg:w-[300px] [&]:xl:h-[164px] [&]:xl:w-[310px]',
                    item.id === 3 && isEn && '[&&]:lg:h-[131px] [&&]:xl:h-[148px]',
                    (item.id === 1 || item.id === 4) && isEn && '[&&&]:lg:h-[153px] [&&&]:xl:h-[164px]',
                    !isEn && '[&&&]:lg:h-[97px] [&&&]:xl:h-[115px]',
                  )}
                  onClick={() => {
                    handleClickCourseTab(item.id, item.tap);
                  }}
                >
                  <div className={cls('mb-2 flex items-center text-left', 'flex-wrap')}>
                    <span
                      className={cls(
                        ' font-semibold text-wk-words-1 lg:text-[16px] xl:text-[18px]',
                        item.tap && '[&]:text-[#fff]',
                      )}
                      dangerouslySetInnerHTML={{ __html: t(item?.title) }}
                    />
                    <div
                      className={cls(
                        'mx-[6px] h-[21px]  rounded-[50px] bg-[linear-gradient(90deg,rgba(255,83,83,0.12)_8.55%,rgba(109,56,251,0.12)_61.14%,rgba(0,157,255,0.12)_100%)] px-[6px] text-center leading-[21px]',
                        item.tap && '[&]:border-[#fff] [&]:bg-[linear-gradient(90deg,#FB515F_5.26%,#FA6E72_96.49%)]',
                      )}
                    >
                      {t(item.age)}
                    </div>
                    <div className="w-full">
                      <div
                        className={cls(
                          'inline-block h-[21px] rounded-[50px] bg-[linear-gradient(90deg,rgba(255,83,83,0.12)_8.55%,rgba(109,56,251,0.12)_61.14%,rgba(0,157,255,0.12)_100%)] px-[6px] text-center leading-[21px]',
                          item.tap &&
                            'px-[6px] [&]:border-[#fff] [&]:bg-[linear-gradient(90deg,#FB515F_5.26%,#FA6E72_96.49%)]',
                          // item.id === 3 && 'hidden',
                          isEn && 'lg:mt-1',
                        )}
                      >
                        {t(item.tag)}
                      </div>
                    </div>
                  </div>
                  <p>{t(item.course)}</p>
                </h3>
              </div>
            ))}
          </div>
          <div>
            {courseRightImgConfig.map((item) => (
              <div
                key={item.id}
                className={cls(
                  `ml-8 hidden lg:h-[354px] lg:w-[608px] xl:h-[354px]  xl:w-[768px]`,
                  courseClickId === item.id && '[&]:block',
                  !isEn && 'lg:mt-[63px] xl:mt-[43px]',
                  isEn && 'lg:mt-[113px] xl:mt-[60px]',
                )}
              >
                <Image
                  className="hidden lg:block lg:rounded-lg xl:block xl:rounded-lg"
                  alt={t('分级课程-alt')}
                  width={768}
                  height={354}
                  src={isEn ? item.imgEn : item.img}
                  quality={100}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="block lg:hidden xl:hidden">
          <div>
            {courseList.map((item) => (
              <div
                key={item.title}
                className={cls(
                  'relative mb-3 rounded-[24px] bg-[#F8F9FF] shadow-[0px_8px_30px_0px_rgba(0,0,0,0.08)] after:absolute after:left-[50%] after:top-0 after:ml-[-138px] after:block after:h-[16px] after:w-[275px] after:bg-[url("/images/chinese/course/shadow.png")] after:bg-contain after:content-[""] lg:bg-transparent xl:bg-transparent',
                  item.id === 1 &&
                    'after:absolute after:left-[50%] after:top-0 after:ml-[-138px] after:block after:h-[16px] after:w-[275px] after:bg-[url("/images/chinese/course/shadow.png")] after:bg-contain after:content-[""]',
                )}
              >
                <div
                  className={cls(
                    'box-border flex cursor-pointer flex-col rounded-xl border-none border-[#EBECFA] bg-[#F8F9FF] p-[24px_20px_18px]  text-left text-[12px] text-wk-words-2 lg:h-[81px] lg:w-[290px] lg:border lg:p-[20px] xl:h-[91px] xl:w-[310px] xl:border xl:p-5',
                    isEn && ' lg:p-3 [&]:lg:h-[131px] [&]:lg:w-[300px] [&]:xl:h-[164px] [&]:xl:w-[310px]',
                    item.id === 3 && isEn && '[&&]:lg:h-[107px] [&&]:xl:h-[124px]',
                    (item.id === 1 || item.id === 4) && isEn && '[&&&]:lg:h-[153px] [&&&]:xl:h-[164px]',
                  )}
                >
                  <div className={cls('mb-2 flex items-center text-left', 'flex-wrap')}>
                    <span
                      className={cls(
                        'text-[20px] font-semibold leading-[24px] text-wk-words-1 lg:text-[16px] xl:text-[18px]',
                      )}
                      dangerouslySetInnerHTML={{ __html: t(item?.title) }}
                    />
                    <div
                      className={cls(
                        'mx-[6px] h-[21px]  rounded-[50px] bg-[linear-gradient(90deg,rgba(255,83,83,0.12)_8.55%,rgba(109,56,251,0.12)_61.14%,rgba(0,157,255,0.12)_100%)] px-[6px] text-center leading-[21px]',
                        isEn && 'text-[13px]',
                      )}
                    >
                      {t(item.age)}
                    </div>
                    <div
                      className={cls(
                        'mt-[6px] h-[21px] rounded-[50px] bg-[linear-gradient(90deg,rgba(255,83,83,0.12)_8.55%,rgba(109,56,251,0.12)_61.14%,rgba(0,157,255,0.12)_100%)] px-[6px] text-center text-[13px] leading-[21px]',
                        isEn && 'lg:mt-1',
                        // item.id === 3 && 'hidden',
                      )}
                    >
                      {t(item.tag)}
                    </div>
                  </div>
                  <p className=" text-sm lg:text-[12px] xl:text-[12px]">{t(item.course)}</p>
                </div>
                <div className="h-[208px] rounded-[24px] bg-white px-4 py-[18px]">
                  <div
                    className={cls(
                      ` m-auto w-[305px] lg:ml-8 lg:mt-[19px] lg:h-[354px]  lg:w-[608px] xl:ml-8 xl:mt-[-29px] xl:h-[354px]  xl:w-[768px]`,
                      isEn && 'lg:ml-6  lg:mt-[239px] xl:mt-[223px] ',
                    )}
                    onClick={() => {
                      handleCourseImgModal(isEn ? item.imgMobileLEn : item.imgMobileL);
                    }}
                  >
                    <Image
                      alt={t('分级课程-alt')}
                      width={768}
                      height={354}
                      src={isEn ? item.imgMobileEn : item.imgMobile}
                      quality={100}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className={cls(
          'container mb-[-5px] mt-[40px]  flex h-[490px] flex-col rounded-[36px] bg-[#fff] lg:mb-10 lg:h-[319px] lg:w-[984px] lg:flex-row lg:p-[40px] lg:shadow-wk1 xl:h-[424px] xl:w-[1220px] xl:flex-row xl:px-[60px] xl:py-[52px] xl:shadow-wk1',
          isEn && 'lg:h-[335px]',
        )}
      >
        <div className="lg:w-[200px] xl:w-[280px]">
          <h3
            className={cls(
              'mb-6 text-[22px] font-bold text-wk-words-1 lg:mb-[12px] lg:mt-[0px] lg:text-[20px] xl:mb-5 xl:mt-[25px] xl:text-[22px]',
              isEn && 'leading-[24px] lg:mb-[8px] lg:mt-[0] lg:text-left xl:mb-0 xl:mt-[0] xl:text-left',
            )}
          >
            {t('分级课程-辅修课-标题')}
          </h3>
          <p
            className={cls(
              'text-center text-base leading-6 text-wk-words-2 lg:w-[200px] lg:text-left lg:text-[14px] lg:leading-6 xl:w-[280px] xl:text-left xl:text-[16px] xl:leading-7',
              isEn && '[&]:lg:leading-[20px] [&]:xl:leading-[24px]',
            )}
          >
            {t('分级课程-辅修课-描述')}
          </p>
          <div
            className={cls(
              'mt-6 hidden items-center justify-end lg:mt-[22px] lg:flex lg:h-[24px] xl:mt-[76px] xl:flex xl:h-[24px]',
              isEn && ' [&]:lg:mt-[8px] [&]:xl:mt-[38px]',
            )}
          >
            <div
              className="h-[24px] w-[24px] cursor-pointer rounded-[50%] p-[6px] hover:bg-[#F5F5FC] lg:h-[20px] lg:w-[20px]"
              onClick={() => {
                swiperRef.current?.slidePrev();
                if (swiperIndex === 1) {
                  setSwiperIndex(minorConfig.length);
                } else {
                  setSwiperIndex(swiperIndex - 1);
                }
              }}
            >
              <Image
                className="rotate-180"
                src="/images/chinese/minor-swiper-icon.png"
                width={10}
                height={10}
                layout="responsive"
                alt="WuKong"
              />
            </div>
            <span className={cls('mx-3 text-wk-words-1 lg:text-[14px]')}>
              {swiperIndex} / <span className="[&]:text-wk-words-1">{minorConfig.length || '3'}</span>
            </span>
            <div
              className="h-[24px] w-[24px] cursor-pointer rounded-[50%] p-[6px] hover:bg-[#F5F5FC] lg:h-[20px] lg:w-[20px]"
              onClick={() => {
                swiperRef.current?.slideNext();
                if (swiperIndex === minorConfig.length) {
                  setSwiperIndex(1);
                } else {
                  setSwiperIndex(swiperIndex + 1);
                }
              }}
            >
              <Image
                src="/images/chinese/minor-swiper-icon.png"
                width={10}
                height={10}
                layout="responsive"
                alt="WuKong"
              />
            </div>
          </div>
        </div>
        <div className="mt-6 lg:ml-10 lg:mt-0 xl:ml-10 xl:mt-0 xl:w-[780px] xl:overflow-hidden">
          <Swiper
            className={cls('w-[899px] lg:w-[682px] xl:w-[899px]')}
            slidesPerView={3}
            loop
            height={304}
            onInit={(swiper: SwiperRef['swiper']) => {
              swiperRef.current = swiper;
            }}
          >
            {minorConfig.map(({ title, img }) => (
              <SwiperSlide key={title} className={cls('mr-0 w-[280px] lg:mr-[1px] lg:w-[209px] xl:w-[340px]')}>
                <div className="rounded-10 relative h-[304px] w-[280px] justify-between lg:h-[284px] lg:w-[249px] xl:h-[348px] xl:w-[310px]">
                  <div className="h-[304px] w-[280px] rounded-[24px] border-[1px] border-none lg:h-[180px] lg:w-[209px] lg:border lg:border-solid xl:h-[248px] xl:w-[280px] xl:border xl:border-solid">
                    <Image
                      className="rounded-[24px] lg:rounded-[16px] xl:rounded-[16px]"
                      src={img}
                      width={280}
                      height={248}
                      layout="responsive"
                      alt={`${t('分级课程-辅修课-alt')} - ${t(title)}`}
                    />
                  </div>
                  <div
                    className={cls(
                      'relative top-[-85px] flex h-[76px] w-[280px] items-center justify-center rounded-[22.4px] px-[16px] text-[18px] font-semibold leading-[76px] text-wk-words-1 lg:relative lg:top-[-15px] lg:h-[66px] lg:w-[208px] lg:rounded-[16px] lg:leading-[66px] xl:h-[76px] xl:w-[280px] xl:rounded-[22.4px] xl:text-[20px] xl:leading-[76px] xl:lg:top-[-30px] [&]:bg-[#fff] [&]:shadow-[0px_8px_30px_0px_rgba(0,0,0,0.06)]',
                      isEn && 'lg:top-[-8px] lg:h-[82px] lg:text-[16px] lg:leading-[82px]',
                    )}
                    style={{ lineHeight: 'normal' }}
                  >
                    {t(title)}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <div className={cls('relative z-10 mb-10', isEn && 'mb-[80px] mt-12 lg:mb-10 lg:mt-0 xl:mb-10 xl:mt-0')}>
        <LeadButton
          className=""
          subject="chinese"
          theme="red"
          size="xl"
          traceName="O_ChineseCourse_TeacherIntroduction_CTAClick"
          traceGa4Name="new_entry_ChineseCourse_TeacherIntroductionCTA"
        >
          {t('分级课程-按钮')}
        </LeadButton>
      </div>
      <Modal
        visible={visible}
        handleClose={() => {
          setVisible(false);
        }}
      >
        <Image className="m-auto" src={modalImgSrc} width={375} height={270} alt="WuKong" />
      </Modal>
    </section>
  );
};

export default Course;
